<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="message">
      <h2>宁东工业超市电子商务平台用户注销规则</h2>
      <div>
        宁东工业超市商城 提醒您，账户一旦注销，您在平台所有的权益（包括但不仅限于积分、优惠券、红包等）都将被视作自动放弃；如果您决定注销账户，需要同时满足以下条件:
        <p class="title-withdraw">1.账户下不存在未完结交易</p>
        须确保您的账户下没有未完全确认收货或者未支付的订单；
        <p class="title-withdraw">2.账户不存在未完结的服务</p>
        须确保您的账户下没有未完成的售后申请、安装服务、课程服务等。
      </div>
      <h2>温馨提示</h2>
      宁东工业超市 商城账户不满足以上任意一项条件则账户无法注销，需在妥善处理所有账户注销相关问题后再提交账户注销申请。
    </div>
    <div class="submit-div">
      <el-button
        type="primary"
        @click="centerDialogVisible = true"
        class="w-percent-100 top-20"
        >同意注销</el-button
      >
    </div>
    <!-- 账户注销确认 -->
    <el-dialog
      title="账户注销确认"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <span
        >申请通过后您将不能再进行购买、售后、咨询等服务，您账户下的所有权益视作自动放弃并失效。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">暂不注销</el-button>
        <el-button type="primary" @click="sureOut" :disabled="btn2Disabled"
          >确认注销</el-button
        >
      </span>
    </el-dialog>
    <!-- 还有交易中的订单 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="disableDialogVisible"
      width="500px"
      center
    >
      <span v-if="code === 2001"
        >您的账户下存在交易进行中的订单，不满足账户销户的条件要求，请在交易全部完成或取消后再申请。</span
      >
      <span v-if="code === 2002"
        >您的账户下存在未过期的课程或者电子书，不满足账户注销要求。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="backHome">返回首页</el-button>
        <el-button type="primary" @click="goOrder">{{
          code === 2001
            ? "查看订单"
            : code === 2002
            ? "查看购买历史"
            : "查看订单"
        }}</el-button>

      </span>
    </el-dialog>
    <!-- 注销验证 -->
    <el-dialog
      title="注销验证"
      :close-on-click-modal="false"
      :visible.sync="visible"
      width="500px"
      center
    >
      <div v-if="visible">
        <span style="margin-bottom: 16px; display: inline-block"
          >为了您的账户安全，请用手机进行验证</span
        >
        <el-form
          label-width="68px"
          :rules="dataRule"
          ref="fastDataForm"
          :model="fastDataForm"
        >
          <el-form-item label="手机号" prop="fastPhone">
            <el-input
              disabled
              v-model="fastDataForm.fastPhone"
              maxlength="20"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            prop="fastCaptcha"
            style="width: 500px; float: left"
          >
            <div style="width: 100%">
              <el-input
                v-model="fastDataForm.fastCaptcha"
                placeholder="请输入验证码"
                maxlength="20"
                style="width: 260px; float: left"
              ></el-input>
              <el-button
                style="
                  padding-left: 15px;
                  width: 120px;
                  float: left;
                  height: 40px;
                  background: #2e88ff;
                  line-height: 0px;
                  color: white;
                  border-radius: 0px;
                "
                @click="sendcode"
                :disabled="disabled"
                >{{ btntxt }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreeWithDraw" :disabled="btnDisabled"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import { clearLoginInfo } from '@/utils'
import { getEnvConfig } from '@/utils/envConfig.js'
export default {
  data () {
    return {
      centerDialogVisible: false,
      visible: false,
      dataRule: {
        fastPhone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }
        ],
        fastCaptcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ]
      },
      fastDataForm: {
        fastPhone: '',
        fastCaptcha: '',
        requestId: ''
      },
      btntxt: '获取验证码',
      disabled: false,
      btnDisabled: false,
      btn2Disabled: false,
      captchaPath: '',
      title: '找回密码',
      disableDialogVisible: false,
      code: ''
    }
  },
  mounted () {
    this.fastDataForm.fastPhone = this.$store.state.user.mobile
  },
  methods: {
    // 判断账户是否可以注销
    sureOut () {
      this.btn2Disabled = true
      this.$http
        .get(`/front/consumer/user/can-canceled`)
        .then((res) => {
          if (res.data.code === 0) {
            this.visible = true
            this.centerDialogVisible = false
          } else {
            if ([2001, 2002].includes(res.data.code)) {
              this.code = res.data.code
              this.disableDialogVisible = true
              this.centerDialogVisible = false
            } else {
              this.$message.error(res.data.message)
            }
          }
          this.btn2Disabled = false
        })
        .catch(() => {
          this.btn2Disabled = false
        })
    },
    backHome () {
      this.$router.push({ name: 'main' })
    },
    goOrder () {
      if (this.code === 2001) {
        this.$router.push({ name: 'orderList' })
      }
      if (this.code === 2002) {
        this.$router.push({ name: 'myBought' })
      }
    },
    // 同意注销按钮
    agreeWithDraw () {
      this.$refs['fastDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.btnDisabled = true
        this.$http
          .post(`/front/consumer/user/canceled`, {
            smsRequestId: this.fastDataForm.requestId,
            validationCode: this.fastDataForm.fastCaptcha
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.visible = false
              this.centerDialogVisible = false
              // 退出登录
              this.$http
                .delete(
                  `/auth/user/token?access_token=${getAccessToken()}&env=${
                    getEnvConfig().env
                  }&domain=${getEnvConfig().domain}&appCode=PLANTMATE_OFFICIAL`,
                  {
                    access_token: getAccessToken()
                  }
                )
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    return false
                  }
                  clearLoginInfo()
                  this.$router.push({ name: 'main' })
                  this.$message.success('注销账户成功')
                  this.$store.commit('resetRefresh', false)
                  this.$nextTick(() => {
                    this.$store.commit('resetRefresh', true)
                  })
                })
                .catch(() => {})
            } else {
              if ([2002, 2003].includes(res.data.code)) {
                this.code = res.data.code - 1
                this.disableDialogVisible = true
              } else {
                this.$message.error(res.data.message)
              }
            }
            this.btnDisabled = false
          })
          .catch(() => {
            this.btnDisabled = false
          })
      })
    },
    // 手机验证发送验证码
    sendcode () {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
      if (this.fastDataForm.fastPhone === '') {
        this.$message({
          message: '手机号不能为空',
          type: 'warning'
        })
        return
      }
      if (!reg.test(this.fastDataForm.fastPhone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else {
        this.fastDataForm.requestId = ''
        this.disabled = true
        // 快捷登录发送验证码
        this.$http
          .get(
            `/front/consumer/user/user-canceled-verification-code?mobile=${this.fastDataForm.fastPhone}`
          )
          .then((res) => {
            if (res.data.code === 0) {
              this.fastDataForm.requestId = res.data.data.requestId
              this.time = 60
              this.timer()
            } else {
              this.getCaptcha()
              this.disabled = false
            }
          })
          .catch(() => {
            this.disabled = false
          })
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后重新获取'
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
        this.getCaptcha()
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.message {
  // padding: 24px;
  line-height: 24px;
  font-size: 16px;
  color: #333333;
  background: #fff;

  h2:first-child {
    margin-top: 0;
  }

  .title-withdraw {
    font-weight: bold;
  }
}
.submit-div {
  width: 40%;
  margin: 0 190px;
}
</style>
